import { Appointment } from "../../appointments/utils";
import { getStartAndEndOfWeek } from "../../../../utils/dateUtils";

export const getAttorneyServiceCount = (appointments: Appointment[]) => {
  let qaCount = 0;
  let representationCount = 0;

  appointments.forEach((appointment) => {
    switch (appointment.purchaseItem.product.productType) {
      case "Q_A":
        qaCount++;
        break;
      case "REPRESENTATION":
      case "POSTNUP_REPRESENTATION":
        representationCount++;
        break;
    }
  });

  return {
    qaCount,
    representationCount,
  };
};

export const getVisibleClients = (appointments: Appointment[]) => {
  return new Set(appointments.map((appointment) => appointment.client)).size;
};

export const getThisWeekAppointments = (appointments: Appointment[]) => {
  const today = new Date();
  const { start, end } = getStartAndEndOfWeek(today);
  return appointments
    .filter((appointment) => {
      const appointmentDate = new Date(appointment.event.eventStartAt);
      return appointmentDate >= start && appointmentDate <= end;
    })
    .sort((a, b) => {
      const timeA = new Date(a.event.eventStartAt).getTime();
      const timeB = new Date(b.event.eventStartAt).getTime();
      return timeA - timeB;
    });
};
